import React from 'react';
import { withTheme } from '@sendpayments/react-shared/components/ThemeProvider';
import styles from './SecondaryFont.module.less';

const SecondaryFont = ({ children }) => <div className={styles.secondaryFont}>{children}</div>;

export default withTheme(SecondaryFont);
